import { IUpdateLicense } from "../UpdateLicense/interface";
import classNames from "classnames";
import { useSharedState } from "../../../../components/services/WindowSizeService";
import "./Log.scss";

import Paho from "paho-mqtt";
import { useEffect, useState } from "react";
import { Config } from "../../../../config/config";
import { Remarkable } from 'remarkable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faTimes } from "@fortawesome/free-solid-svg-icons";
import { alertService } from "../../Services/alertService";
import Loader from "../../Loader/Loader";
import { authorizationService } from "../../../api_services/authorizationService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";



let client: any = new Paho.Client(
    'app.ilens.io',
    Number(443),
    'clientId_' + new Date().getTime()
);


const Log = (props: IUpdateLicense) => {
    var md = new Remarkable();
    const { onClose, onSubmit, title } = props;
    const windowSize$ = useSharedState();
    const [loader, setLoader] = useState<boolean>(true);
    const [connectedData, setConnectedData] = useState<any>([]);
    const [firstMessage, setFirstMessage] = useState<any>();
    let fMessage: any;
    const [connectStatus, setConnectStatus] = useState<any>(false);

    let payLoad: any = getURLDataMethod();

    useEffect(() => {
        let objDiv: any = document.getElementById("container-log");
        if (objDiv?.scrollTop) {
            objDiv.scrollTop = objDiv?.scrollHeight;
        }
        else if (objDiv?.scrollTop === 0) {
            objDiv.scrollTop = objDiv?.scrollHeight;
        }
    }, [connectedData?.length, connectedData])

    useEffect(() => {
        localStorage.setItem('logData', "false");
    }, [])

    const [value, setValue] = useState(0);

    const onMessage = (message?: any) => {
        let reqBValue: any = localStorage.getItem('logData');
        if (message && message?.destinationName === "scn/logs/" + payLoad?.device_id) {
            if (reqBValue === "true") {
                setValue(parseInt(message.payloadString));
                if (fMessage && connectedData?.length === 0) {
                    connectedData.push(fMessage);
                }
                connectedData.push("<span><b>" + formatTime(new Date()) + "</b></span>" + " : " + message.payloadString);
                setConnectedData(JSON.parse(JSON.stringify(connectedData)))
                onMqttMessageArrived(message)
            }
            else {
                let temp: any = [];
                temp.push("<span><b>" + formatTime(new Date()) + "</b></span>" + " : " + message.payloadString);
                connectedData.length = 0;
                fMessage = "<span><b>" + formatTime(new Date()) + "</b></span>" + " : " + message.payloadString;
                setFirstMessage(fMessage)
                setConnectedData(temp)
                onMqttMessageArrived(message)
                localStorage.setItem('logData', "true");
            }
        }
    }

    const formatTime = (dateTime: any) => {
        try {
            const date = new Date(dateTime);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
            const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            const dateFormat = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
            return dateFormat;
        } catch (error) {
            console.error(error);
        }
    }

    const renderMarkdownToHTML = (markdown: any) => {
        const renderedHTML = md.render(markdown);
        return { __html: renderedHTML };
    }

    const onMqttMessageArrived = (message: any) => {
        // let objDiv : any = document.getElementById("container-log");
        // objDiv.scrollTop = objDiv.scrollHeight;
        // const element: any = document.getElementById('container-log');
        // element.scrollTo(0, element.body.scrollHeight);
        // connectedData.push(formatTime(new Date()) + " : " + message.payloadString);
        // setTimeout(() => {
        //     setConnectedData(connectedData)
        // }, 1000)
    }

    const onDownload = async (deviceID: any) => {
        const payload = JSON.parse(JSON.stringify(payLoad));
        if (payload && payload['firmware_version']) {
            const device = payload['device_type']?.split('iLens-')[1];
            try {
                return await authorizationService.downloadLog("getUrlData", payload, device, payload['firmware_version'], deviceID, {}).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body))
                            const url = window.URL.createObjectURL(
                                new Blob([response]),
                            );
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute(
                                'download',
                                `${deviceID}.csv`,
                            );
                            document.body.appendChild(link);
                            link.click();
                            link?.parentNode?.removeChild(link);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        alertService?.serviceErrorMessage(res?.response?.data?.message)
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }


    useEffect(() => {
        client.connect({
            useSSL: Config.CONSTANTS.MQTT.useSSL,
            userName: Config.CONSTANTS.MQTT.userName,
            password: Config.CONSTANTS.MQTT.password,
            onSuccess: () => {
                setConnectStatus(true);
                alertService.serviceSuccessMessage("Connected")
                setLoader(false);
                console.log("Connected!");
                client.subscribe("scn/logs/" + payLoad?.device_id);
                client.onMessageArrived = onMessage;
            },
            keepAliveInterval: 20,
            onFailure: () => {
                alertService.serviceErrorMessage("Failed to connect!")
                console.log("Failed to connect!");
            }
        });
    }, [])

    const changeValue = (c: any) => {
        const message = new Paho.Message((value + 1).toString());
        message.destinationName = "mqtt-async-test/value";
        c.send(message);
    }

    const closeLogModal = () => {
        onClose && onClose(false);
        try {
            if (connectStatus) {
                setConnectStatus(false);
                setLoader(false);
                client.disconnect();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const clearLog = () => {
        setTimeout(() => {
            localStorage.setItem('logData', "false");
        }, 10);
        setConnectedData([]);
    }

    return (
        <div className="log">
            <div className="modal-header modal-header-wrapper">
                <div>
                    <span id="header" className="modal-title w-100"> {title} </span>
                </div>
                <div className="font-icon" onClick={closeLogModal}>
                    <FontAwesomeIcon icon={faTimes} className="mx-1 menu-link-hoverable pointer" data-dismiss="modal" />
                </div>
            </div>
            <div> {loader ?
                <Loader hasError={false} /> :
                <>
                    {connectedData?.length && connectedData ?
                        <div className={classNames("modal-body py-3 events-none",
                            {
                                "drawer-body": windowSize$ === "sm" || windowSize$ === "xs",
                                "dr": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                            })} >
                            <div className="container-log py-2 px-1" id="container-log">
                                {connectedData.map((item: any) => {
                                    return (
                                        <div dangerouslySetInnerHTML={{ __html: item }}>{ }</div>
                                    )
                                })
                                }
                            </div>
                        </div >
                        :
                        <h4 className={classNames("modal-body events-none",
                            {
                                "drawer-body empty-log-div-small": windowSize$ === "sm" || windowSize$ === "xs",
                                "dr empty-log-div-md": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                            })}>Waiting for Device Log Data...</h4>
                    }
                </>
            }
            </div>
            <div className="no-border-footer modal-footer justify-content-center" >
                <div>
                    {/* disabled={!connectedData?.length ? true : false} */}
                    <button className="btn btn-primary" onClick={() => { onDownload(payLoad?.device_id) }}>Download <FontAwesomeIcon icon={faDownload} /></button>
                </div>
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={closeLogModal}>Close</button>
                    <button disabled={!connectedData?.length ? true : false} attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={clearLog}>Clear Log</button>
                </div>
            </div>
        </div>
    )
}
export default Log;